
import { StrictMode, useEffect } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { SimpleAuthProvider } from "@/hooks/auth";
import { initPerformanceTracking } from "@/utils/initPerformanceTracking";
import App from "./App.tsx";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1 * 60 * 1000,        // Data fresh for 1 minute (reduced from 2 min)
      gcTime: 5 * 60 * 1000,           // Keep in cache for 5 minutes  
      refetchOnWindowFocus: false,      // Stop refetching on every tab switch
      refetchOnMount: true,             // Allow refetch on mount for fresh data
      retry: 1,                         // Quick failure, don't retry 3x
      refetchOnReconnect: true,         // Refetch when internet reconnects
    },
  },
});

// Phase 7: Initialize performance tracking
if (typeof window !== 'undefined') {
  initPerformanceTracking();
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <SimpleAuthProvider>
        <TooltipProvider>
          <App />
          <Toaster />
        </TooltipProvider>
      </SimpleAuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
